var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('post-header',{attrs:{"header":_vm.post.header}}),_vm._l((_vm.post.sections),function(section,index){return _c('post-section',{key:'post-section-' + index,attrs:{"section":section}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }